import debounce from 'lodash/debounce';

const applyNavShadow = () => {
  const header = document.getElementById('header-desktop');
  if (header) {
    window.addEventListener(
      'scroll',
      debounce(() => {
        if (window.scrollY > 0) {
          header.classList.add('shadow-lg');
        } else {
          header.classList.remove('shadow-lg');
        }
      }, 250)
    );
  }
};

const noScrollNav = () => {
  const openNav = document.getElementById('open-nav-toggle') as HTMLInputElement;

  // Remove this once the public header is updated.
  if (!openNav) return;

  const closeNav = document.getElementById('close-nav-toggle') as HTMLInputElement;
  const mobileNavPanel = document.getElementById('nav-panel-mobile') as HTMLElement;

  const body = document.querySelector('body') as HTMLElement;

  openNav.addEventListener('click', () => {
    body.classList.add('overflow-hidden');
    openNav.classList.add('hidden');
    closeNav.classList.remove('hidden');
    mobileNavPanel.classList.remove('hidden');
  });

  closeNav.addEventListener('click', () => {
    body.classList.remove('overflow-hidden');
    openNav.classList.remove('hidden');
    closeNav.classList.add('hidden');
    mobileNavPanel.classList.add('hidden');
  });
};

const desktopNavDropdown = () => {
  const openDesktopNavDropdown = document.getElementById('nav-dropdown-desktop-open') as HTMLInputElement;

  // Remove this once the public header is updated.
  if (!openDesktopNavDropdown) return;

  const closeDesktopNavDropdown = document.getElementById('nav-dropdown-desktop-close') as HTMLInputElement;
  const desktopNavDropdownPanel = document.getElementById('nav-dropdown-desktop-panel') as HTMLElement;

  openDesktopNavDropdown.addEventListener('click', () => {
    desktopNavDropdownPanel.classList.remove('hidden');
  });

  closeDesktopNavDropdown.addEventListener('click', () => {
    desktopNavDropdownPanel.classList.add('hidden');
  });
};

applyNavShadow();
noScrollNav();
desktopNavDropdown();
